// @flow

import Game from '@/lib/game';
import Cell from '@/lib/cell';
import UnitManager from '@/lib/unit_manager';
import {
  AffectEvent,
  DieEvent,
  EvolveEvent,
  AbsorbSunlightEvent,
  GrowHeightEvent,
  AgeEvent,
} from '@/lib/unit_event';

export default class {
  manager: UnitManager;
  id: number;
  template: UnitTemplate;
  cell: Cell;
  status: string;
  age: number;
  treeHeight: number;
  treeSunlight: number;
  events: UnitEventCallable[];
  deadTime: number;

  constructor(params: {
    manager: UnitManager,
    id: number,
    template: UnitTemplate,
    cell: Cell,
  }) {
    this.manager = params.manager;
    this.id = params.id;
    this.template = params.template;
    this.cell = params.cell;
    this.events = [
      AffectEvent,
      DieEvent,
      EvolveEvent,
      AbsorbSunlightEvent,
      GrowHeightEvent, // AbsorbSunlightEvent よりも後でなければならない
      AgeEvent,
    ];
    this.status = 'alive';
    this.age = 0;
    this.treeHeight = 0.9;
    this.treeSunlight = 0; // 日光量は蓄積しない（毎ウェーブ計算される）
    this.deadTime = 0;
  }

  get vueId() {
    return `${this.id}-${this.template.type}`;
  }

  process() {
    this.events.forEach(event => event.process(this));
  }

  getParameter(target: string, field: string): any {
    // 同種間でしか virus の影響を受けない
    // if (field == "virus") field = this.virusType;

    // $FlowFixMe:
    if (target == 'unit') return this[field];
    // $FlowFixMe:
    if (target == 'cell') return this.cell[field];

    return false;
  }

  // 伐採し、その価値を返す
  cut(): number {
    if (this.status === 'cut' || this.isDead()) return 0;

    const value = this.valuate();
    this.status = 'cut';
    this.manager.tryDelete(this);
    this.notifyOnCut(this.manager.game);
    return value;
  }

  isAlive() {
    return this.status == 'alive';
  }

  isDead() {
    return this.status == 'dead';
  }

  isCut() {
    return this.status == 'cut';
  }

  notifyOnCut(game: Game) {
    if (
      typeof this.template.skipNotify !== 'undefined' &&
      this.template.skipNotify === true
    )
      return;

    game.notify(notificationManager => {
      notificationManager.create({
        title: `${this.template.name}を伐採しました`,
        level: 'low',
        unit: this,
      });
    });
  }

  valuate() {
    if (this.isDead() || this.isCut()) {
      return 0;
    }

    // 樹高のみを用いて価値計算をする
    return Math.round(this.treeHeight * 10);
  }

  _restrictValue(value: number, max: number = 100, min: number = 0) {
    if (value > max) {
      return max;
    } else if (value < min) {
      return min;
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/lib/unit/unit.js